import { render } from "./DataTopLogged.vue?vue&type=template&id=19639e54&scoped=true"
import script from "./DataTopLogged.vue?vue&type=script&lang=js"
export * from "./DataTopLogged.vue?vue&type=script&lang=js"

import "./DataTopLogged.vue?vue&type=style&index=0&id=19639e54&scoped=true&lang=css"

import exportComponent from "E:\\GIT\\WEB\\catch-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19639e54"]])

export default __exports__